export const generatedTrajectoryValidationMatrix = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-21T00:00:00.000Z",
  "mode": "deterministic-trajectory-validation-matrix",
  "operatingRule": "Trajectory validation records explain whether SPICE/Orekit/GMAT/Tudat evidence can influence scenario rankings. They fail closed until runtime artifacts, independent comparisons, and before/after decision deltas are attached.",
  "rowCount": 4,
  "blockedRowCount": 4,
  "decisionUseAllowed": false,
  "customerUseAllowed": false,
  "commercialUseAllowed": false,
  "evidenceStateCounts": {
    "promoted-currently-reproducible": 1,
    "scaffold-or-contract-only-not-decision-evidence": 3
  },
  "evidenceHashes": {
    "sidecarPromotionLedger": "sha256-ac772d0c153dc9cb61ecb3605e1fd9c8c15eac4fb7e4977ffa014f84d0368ba6",
    "sidecarReadinessLedger": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8",
    "runtimeValidationCampaignLedger": "sha256-7d6f913ac6a611baf6052809984397293a597736628121801cff5135edc9a45b",
    "runtimeClosurePacket": "sha256-67b23b0dec664b27b660c3d364a8613c35e7b87b21141f65e88ed7951a57527d",
    "sidecarRunSpecPacket": "sha256-ce4ff5977802635c5e8c813974453dba222a297a374ab09f9e58d7d61b843d3e",
    "sidecarWorkOrderPacket": "sha256-8e6bf30aec2a64bb3dfd0d7eaad748c8579454fb6d285b83b557a955c0ace4e4",
    "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13"
  },
  "acceptanceRules": [
    "Runtime artifact must be generated by the named sidecar worker, not hand-authored from a scaffold.",
    "Artifact must pass scripts/validate-sidecar-intake.mjs with validationStatus passed.",
    "Independent comparison must pass for Orekit, GMAT, and Tudat contract rows.",
    "Before/after scenario decision deltas must be attached before any ranking or customer answer changes.",
    "Customer use remains blocked until source-use, model-validation, and reviewer approval gates also pass."
  ],
  "rows": [
    {
      "contractId": "spice-gf-event-window-v1",
      "tool": "NASA NAIF SPICE Geometry Finder",
      "domain": "ephemeris-event-windows",
      "sourceIds": [
        "spice-gf"
      ],
      "validationLane": "event-window-custody",
      "requiredFieldCount": 16,
      "requiredFields": [
        "toolVersion",
        "runAt",
        "scenarioId",
        "kernelSet",
        "kernelHashes",
        "timeScale",
        "gfConstraint",
        "eventWindows",
        "units",
        "uncertainty",
        "reproducibleCommand",
        "inputsHash",
        "outputsHash",
        "checksums",
        "limitations",
        "validationStatus"
      ],
      "promotionRule": "SPICE event windows can promote only when kernel hashes, time scale, GF constraints, generated windows, and checksum evidence are attached.",
      "readinessState": "runtime-artifact-promoted",
      "reproducibilityState": "promoted-artifact-currently-reproducible",
      "closureState": "closed-currently-reproducible",
      "currentEvidenceState": "promoted-currently-reproducible",
      "promotedArtifact": {
        "artifactId": "spice-gf-runtime-mercury-clear-link-nonzero-window-proof-2025-08",
        "artifactHash": "sha256-ac59ad01e58f7d228c7cc412dcadaa40000f1e249a68c99ab6496dc17cccabf1",
        "reportHash": "sha256-7d837f800c33851d36e7f8e2974036603e22cd4cd16c8a05296ded824c11e908",
        "validationHash": "sha256-0e447e7bc3b17a578af3a924a9419b42ea2bf2c23ccd6127e6bf9fd0a5a4528c"
      },
      "requiredIndependentComparison": {
        "required": false,
        "status": "not-required-by-contract",
        "acceptedComparators": []
      },
      "scenarioRefs": [
        {
          "scenarioId": "hybrid",
          "rank": 2,
          "decisionLane": "lane-3-watchlist",
          "decisionReadinessScore": 59.78,
          "decisionHash": "sha256-d1291337540a1d709dbf14299fe94a0c514a6f2fdc474b3eceec237a4bb9b803"
        },
        {
          "scenarioId": "mercury-orbit",
          "rank": 4,
          "decisionLane": "lane-4-research-backlog",
          "decisionReadinessScore": 44.15,
          "decisionHash": "sha256-3d2d82c36b7e046f9493f8b8f110374461d2bda863c9092e5df482160f350ab4"
        },
        {
          "scenarioId": "moon-first",
          "rank": 1,
          "decisionLane": "lane-2-conditional-diligence",
          "decisionReadinessScore": 62.91,
          "decisionHash": "sha256-10d9dbf8c908ecc11f38b876ad8b0973845d4b803124a1ce5d524cdd72f1422c"
        }
      ],
      "campaignRefs": [
        {
          "id": "campaign-spice-contact-windows",
          "title": "SPICE contact and solar-interference windows",
          "status": "runtime-promoted-currently-reproducible",
          "priorityLane": "P0-critical-path",
          "campaignHash": "sha256-462420fcd20cbc0ba392b0abb149494b622e04cfd25b622c7e86c32a8f797fc3"
        }
      ],
      "runSpecRef": {
        "id": "run-spec-spice-gf-event-window-v1",
        "runSpecHash": "sha256-a416865942c7d332b206a4cebcfc9068c9006dbf4222dc7dbc26437a2b986f4c",
        "outputPath": "artifacts/sidecars/spice-gf-event-window-v1.json",
        "commandTemplate": "python sidecars/spice_gf/run_spice_gf.py --scenario <scenarioId> --kernel-manifest <kernelManifest.json> --constraints <constraints.json> --out artifacts/sidecars/spice-gf-event-window-v1.json",
        "acceptanceGates": [
          "Artifact id, contract id, scenario id, tool version, run timestamp, source ids, units, uncertainty, limitations, and validation status are populated.",
          "inputsHash, outputsHash, checksums, and reproducibleCommand are populated and stable across reruns.",
          "Output JSON validates through `npm run science:sidecar:intake` without blockers.",
          "The artifact remains non-promotional until the generated intake report is reviewed and placed under evidence/sidecar-intake-reports.",
          "SPICE kernel coverage, TDB/ET time key, confinement window, GF constraint, and event-window endpoints are recorded."
        ]
      },
      "workOrderRef": {
        "id": "work-order-spice-gf-event-window-v1",
        "workOrderHash": "sha256-28129dc4f5b602e71d08f8d395f99a34f947b41c576c5b070c8a2c010456ce42",
        "commandTemplate": "python sidecars/spice_gf/run_spice_gf.py --scenario <scenarioId> --kernel-manifest <kernelManifest.json> --constraints <constraints.json> --out artifacts/sidecars/spice-gf-event-window-v1.json",
        "requiredOutputPath": "artifacts/sidecars/spice-gf-event-window-v1.json"
      },
      "blockers": [],
      "decisionUseAllowed": false,
      "customerUseAllowed": false,
      "commercialUseAllowed": false,
      "nextAction": "Regenerate current-shell preflight and reviewer acceptance before using the promoted artifact in customer deliverables.",
      "rowHash": "sha256-8506f128527eb85f84c4d763357e0ae33902ebadd9aa01989b88ba464789cd3a"
    },
    {
      "contractId": "orekit-propagation-v1",
      "tool": "Orekit",
      "domain": "trajectory-propagation",
      "sourceIds": [
        "orekit"
      ],
      "validationLane": "trajectory-propagation",
      "requiredFieldCount": 17,
      "requiredFields": [
        "toolVersion",
        "runAt",
        "scenarioId",
        "dataContext",
        "frames",
        "timeScale",
        "forceModel",
        "events",
        "units",
        "uncertainty",
        "reproducibleCommand",
        "inputsHash",
        "outputsHash",
        "checksums",
        "independentComparison",
        "limitations",
        "validationStatus"
      ],
      "promotionRule": "Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
      "readinessState": "blocked-runtime-prerequisites",
      "reproducibilityState": "no-promoted-artifact-runtime-blocked",
      "closureState": "blocked-before-runtime-generation",
      "currentEvidenceState": "scaffold-or-contract-only-not-decision-evidence",
      "promotedArtifact": null,
      "requiredIndependentComparison": {
        "required": true,
        "status": "blocked-until-independent-comparison-passes",
        "acceptedComparators": [
          "GMAT",
          "Tudat",
          "two-body residual check"
        ]
      },
      "scenarioRefs": [
        {
          "scenarioId": "asteroid-first",
          "rank": 3,
          "decisionLane": "lane-4-research-backlog",
          "decisionReadinessScore": 41.63,
          "decisionHash": "sha256-d9790d0c91f9265c9681ca6b04883b642500ac3e7a16d26dbf169e61ea5bd051"
        },
        {
          "scenarioId": "hybrid",
          "rank": 2,
          "decisionLane": "lane-3-watchlist",
          "decisionReadinessScore": 59.78,
          "decisionHash": "sha256-d1291337540a1d709dbf14299fe94a0c514a6f2fdc474b3eceec237a4bb9b803"
        },
        {
          "scenarioId": "mercury-orbit",
          "rank": 4,
          "decisionLane": "lane-4-research-backlog",
          "decisionReadinessScore": 44.15,
          "decisionHash": "sha256-3d2d82c36b7e046f9493f8b8f110374461d2bda863c9092e5df482160f350ab4"
        },
        {
          "scenarioId": "moon-first",
          "rank": 1,
          "decisionLane": "lane-2-conditional-diligence",
          "decisionReadinessScore": 62.91,
          "decisionHash": "sha256-10d9dbf8c908ecc11f38b876ad8b0973845d4b803124a1ce5d524cdd72f1422c"
        }
      ],
      "campaignRefs": [
        {
          "id": "campaign-orekit-propagation",
          "title": "Orekit propagation and event checks",
          "status": "blocked-runtime-prerequisites",
          "priorityLane": "P0-critical-path",
          "campaignHash": "sha256-34e5be85925dbc6bf6a3acb190d67f8c3d409469f12f69f7ca321872ac2e6a33"
        },
        {
          "id": "campaign-cross-tool-residual-frontier",
          "title": "Cross-tool residual frontier",
          "status": "blocked-runtime-prerequisites",
          "priorityLane": "P0-critical-path",
          "campaignHash": "sha256-8e5b0be0f6654f91a37027e198b2e9d892fc3d05e9415ab90f90f520d2e06638"
        }
      ],
      "runSpecRef": {
        "id": "run-spec-orekit-propagation-v1",
        "runSpecHash": "sha256-6760d4cf3d986ffb70f72246168ab2562bc9b35b7dc40400d0cba01b759d29dd",
        "outputPath": "artifacts/sidecars/orekit-propagation-v1.json",
        "commandTemplate": "java -jar sidecars/orekit/build/libs/orekit-sidecar.jar --scenario <scenarioId> --data-context <orekit-data.zip> --out artifacts/sidecars/orekit-propagation-v1.json",
        "acceptanceGates": [
          "Artifact id, contract id, scenario id, tool version, run timestamp, source ids, units, uncertainty, limitations, and validation status are populated.",
          "inputsHash, outputsHash, checksums, and reproducibleCommand are populated and stable across reruns.",
          "Output JSON validates through `npm run science:sidecar:intake` without blockers.",
          "The artifact remains non-promotional until the generated intake report is reviewed and placed under evidence/sidecar-intake-reports.",
          "independentComparison.status is passed and residual bounds are recorded against at least one independent tool or reviewed reference artifact."
        ]
      },
      "workOrderRef": {
        "id": "work-order-orekit-propagation-v1",
        "workOrderHash": "sha256-69e531fee46ffac8b1b6865c5bc3cc5248c7b3d18f193615a03cd44aedd404b7",
        "commandTemplate": "java -jar sidecars/orekit/build/libs/orekit-sidecar.jar --scenario <scenarioId> --data-context <orekit-data.zip> --out artifacts/sidecars/orekit-propagation-v1.json",
        "requiredOutputPath": "artifacts/sidecars/orekit-propagation-v1.json"
      },
      "blockers": [
        "Current-shell reproducibility is not closed for decision use.",
        "Missing command/runtime: Java",
        "Missing path or env input: OREKIT_DATA_PATH",
        "Missing path or env input: OREKIT_SIDECAR_JAR",
        "No promoted runtime artifact is available for this contract.",
        "Runtime artifact is not promoted."
      ],
      "decisionUseAllowed": false,
      "customerUseAllowed": false,
      "commercialUseAllowed": false,
      "nextAction": "Resolve runtime prerequisites: Missing command/runtime: Java; Missing path or env input: OREKIT_DATA_PATH; Missing path or env input: OREKIT_SIDECAR_JAR.",
      "rowHash": "sha256-825316e273fc8cdcc997f876fd2a9533f1936ba2ef1d3bd33713ecc60b2f9fcc"
    },
    {
      "contractId": "gmat-transfer-v1",
      "tool": "NASA GMAT",
      "domain": "mission-design-transfer",
      "sourceIds": [
        "gmat"
      ],
      "validationLane": "mission-design-transfer",
      "requiredFieldCount": 18,
      "requiredFields": [
        "gmatVersion",
        "runAt",
        "scenarioId",
        "scriptHash",
        "epoch",
        "forceModel",
        "optimizer",
        "trajectorySummary",
        "constraintSummary",
        "units",
        "uncertainty",
        "reproducibleCommand",
        "inputsHash",
        "outputsHash",
        "checksums",
        "independentComparison",
        "limitations",
        "validationStatus"
      ],
      "promotionRule": "GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
      "readinessState": "blocked-runtime-prerequisites",
      "reproducibilityState": "no-promoted-artifact-runtime-blocked",
      "closureState": "blocked-before-runtime-generation",
      "currentEvidenceState": "scaffold-or-contract-only-not-decision-evidence",
      "promotedArtifact": null,
      "requiredIndependentComparison": {
        "required": true,
        "status": "blocked-until-independent-comparison-passes",
        "acceptedComparators": [
          "Orekit",
          "Tudat"
        ]
      },
      "scenarioRefs": [
        {
          "scenarioId": "asteroid-first",
          "rank": 3,
          "decisionLane": "lane-4-research-backlog",
          "decisionReadinessScore": 41.63,
          "decisionHash": "sha256-d9790d0c91f9265c9681ca6b04883b642500ac3e7a16d26dbf169e61ea5bd051"
        },
        {
          "scenarioId": "hybrid",
          "rank": 2,
          "decisionLane": "lane-3-watchlist",
          "decisionReadinessScore": 59.78,
          "decisionHash": "sha256-d1291337540a1d709dbf14299fe94a0c514a6f2fdc474b3eceec237a4bb9b803"
        },
        {
          "scenarioId": "mercury-orbit",
          "rank": 4,
          "decisionLane": "lane-4-research-backlog",
          "decisionReadinessScore": 44.15,
          "decisionHash": "sha256-3d2d82c36b7e046f9493f8b8f110374461d2bda863c9092e5df482160f350ab4"
        },
        {
          "scenarioId": "moon-first",
          "rank": 1,
          "decisionLane": "lane-2-conditional-diligence",
          "decisionReadinessScore": 62.91,
          "decisionHash": "sha256-10d9dbf8c908ecc11f38b876ad8b0973845d4b803124a1ce5d524cdd72f1422c"
        }
      ],
      "campaignRefs": [
        {
          "id": "campaign-gmat-transfer",
          "title": "GMAT transfer and constraint residuals",
          "status": "blocked-runtime-prerequisites",
          "priorityLane": "P0-critical-path",
          "campaignHash": "sha256-c53e6e950ae8a2f0c08b1e20e266a4cedbcd3a50650849182257416abec9feb2"
        },
        {
          "id": "campaign-cross-tool-residual-frontier",
          "title": "Cross-tool residual frontier",
          "status": "blocked-runtime-prerequisites",
          "priorityLane": "P0-critical-path",
          "campaignHash": "sha256-8e5b0be0f6654f91a37027e198b2e9d892fc3d05e9415ab90f90f520d2e06638"
        }
      ],
      "runSpecRef": {
        "id": "run-spec-gmat-transfer-v1",
        "runSpecHash": "sha256-0557d81b6167b827573059307a15c3621f69f6b35008f5bdef748f9280fee3d8",
        "outputPath": "artifacts/sidecars/gmat/gmat-transfer-v1.json",
        "commandTemplate": "python sidecars/gmat/run_gmat_transfer.py --scenario <scenarioId> --manifest <gmat-script-manifest.json> --report <reviewed-gmat-run-report.json> --out artifacts/sidecars/gmat/gmat-transfer-v1.json",
        "acceptanceGates": [
          "Artifact id, contract id, scenario id, tool version, run timestamp, source ids, units, uncertainty, limitations, and validation status are populated.",
          "inputsHash, outputsHash, checksums, and reproducibleCommand are populated and stable across reruns.",
          "Output JSON validates through `npm run science:sidecar:intake` without blockers.",
          "The artifact remains non-promotional until the generated intake report is reviewed and placed under evidence/sidecar-intake-reports.",
          "independentComparison.status is passed and residual bounds are recorded against at least one independent tool or reviewed reference artifact."
        ]
      },
      "workOrderRef": {
        "id": "work-order-gmat-transfer-v1",
        "workOrderHash": "sha256-fe29e92d043ca958978f5f4495f54e42bb1b84cdf0965ca5db25f5e77b1f0b8d",
        "commandTemplate": "python sidecars/gmat/run_gmat_transfer.py --scenario <scenarioId> --manifest <gmat-script-manifest.json> --report <reviewed-gmat-run-report.json> --out artifacts/sidecars/gmat/gmat-transfer-v1.json",
        "requiredOutputPath": "artifacts/sidecars/gmat/gmat-transfer-v1.json"
      },
      "blockers": [
        "Current-shell reproducibility is not closed for decision use.",
        "Missing command/runtime: GMAT",
        "No promoted runtime artifact is available for this contract.",
        "Runtime artifact is not promoted."
      ],
      "decisionUseAllowed": false,
      "customerUseAllowed": false,
      "commercialUseAllowed": false,
      "nextAction": "Resolve runtime prerequisites: Missing command/runtime: GMAT.",
      "rowHash": "sha256-1ce3857516f141552346c0ea55083351afbbb42137b6ba435d7b08d7e95ad4c1"
    },
    {
      "contractId": "tudat-transfer-v1",
      "tool": "Tudat",
      "domain": "cross-tool-trajectory-validation",
      "sourceIds": [
        "tudat"
      ],
      "validationLane": "cross-tool-transfer-check",
      "requiredFieldCount": 17,
      "requiredFields": [
        "toolVersion",
        "runAt",
        "scenarioId",
        "bodySettings",
        "integrator",
        "propagatorSettings",
        "trajectorySummary",
        "residualSummary",
        "units",
        "uncertainty",
        "reproducibleCommand",
        "inputsHash",
        "outputsHash",
        "checksums",
        "independentComparison",
        "limitations",
        "validationStatus"
      ],
      "promotionRule": "Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented.",
      "readinessState": "blocked-runtime-prerequisites",
      "reproducibilityState": "no-promoted-artifact-runtime-blocked",
      "closureState": "blocked-before-runtime-generation",
      "currentEvidenceState": "scaffold-or-contract-only-not-decision-evidence",
      "promotedArtifact": null,
      "requiredIndependentComparison": {
        "required": true,
        "status": "blocked-until-independent-comparison-passes",
        "acceptedComparators": [
          "Orekit",
          "GMAT"
        ]
      },
      "scenarioRefs": [
        {
          "scenarioId": "asteroid-first",
          "rank": 3,
          "decisionLane": "lane-4-research-backlog",
          "decisionReadinessScore": 41.63,
          "decisionHash": "sha256-d9790d0c91f9265c9681ca6b04883b642500ac3e7a16d26dbf169e61ea5bd051"
        },
        {
          "scenarioId": "hybrid",
          "rank": 2,
          "decisionLane": "lane-3-watchlist",
          "decisionReadinessScore": 59.78,
          "decisionHash": "sha256-d1291337540a1d709dbf14299fe94a0c514a6f2fdc474b3eceec237a4bb9b803"
        },
        {
          "scenarioId": "mercury-orbit",
          "rank": 4,
          "decisionLane": "lane-4-research-backlog",
          "decisionReadinessScore": 44.15,
          "decisionHash": "sha256-3d2d82c36b7e046f9493f8b8f110374461d2bda863c9092e5df482160f350ab4"
        }
      ],
      "campaignRefs": [
        {
          "id": "campaign-tudat-cross-check",
          "title": "Tudat third-tool trajectory cross-check",
          "status": "blocked-runtime-prerequisites",
          "priorityLane": "P0-critical-path",
          "campaignHash": "sha256-acf23215d3bb46936335c11ff99cc341490a625810d4895ab6894955cf54ab38"
        },
        {
          "id": "campaign-cross-tool-residual-frontier",
          "title": "Cross-tool residual frontier",
          "status": "blocked-runtime-prerequisites",
          "priorityLane": "P0-critical-path",
          "campaignHash": "sha256-8e5b0be0f6654f91a37027e198b2e9d892fc3d05e9415ab90f90f520d2e06638"
        }
      ],
      "runSpecRef": {
        "id": "run-spec-tudat-transfer-v1",
        "runSpecHash": "sha256-f67dfda77ada00ef1724aa13e103ecd7be2d0e9e02418042971bc39a22369e39",
        "outputPath": "artifacts/sidecars/tudat/tudat-transfer-v1.json",
        "commandTemplate": "python sidecars/tudat/run_tudat_transfer.py --scenario <scenarioId> --settings <bodySettings.json> --report <reviewed-tudat-run-report.json> --out artifacts/sidecars/tudat/tudat-transfer-v1.json",
        "acceptanceGates": [
          "Artifact id, contract id, scenario id, tool version, run timestamp, source ids, units, uncertainty, limitations, and validation status are populated.",
          "inputsHash, outputsHash, checksums, and reproducibleCommand are populated and stable across reruns.",
          "Output JSON validates through `npm run science:sidecar:intake` without blockers.",
          "The artifact remains non-promotional until the generated intake report is reviewed and placed under evidence/sidecar-intake-reports.",
          "independentComparison.status is passed and residual bounds are recorded against at least one independent tool or reviewed reference artifact."
        ]
      },
      "workOrderRef": {
        "id": "work-order-tudat-transfer-v1",
        "workOrderHash": "sha256-762279e25442533a1eb05a89ea533c13c672334e6f1bc44279885dc56a2d8ff8",
        "commandTemplate": "python sidecars/tudat/run_tudat_transfer.py --scenario <scenarioId> --settings <bodySettings.json> --report <reviewed-tudat-run-report.json> --out artifacts/sidecars/tudat/tudat-transfer-v1.json",
        "requiredOutputPath": "artifacts/sidecars/tudat/tudat-transfer-v1.json"
      },
      "blockers": [
        "Current-shell reproducibility is not closed for decision use.",
        "Missing Python module: tudatpy",
        "No promoted runtime artifact is available for this contract.",
        "Runtime artifact is not promoted."
      ],
      "decisionUseAllowed": false,
      "customerUseAllowed": false,
      "commercialUseAllowed": false,
      "nextAction": "Resolve runtime prerequisites: Missing Python module: tudatpy.",
      "rowHash": "sha256-3f182eeb0857e51a41d03b37b28f284aba4c9894ef7b9dcae5ca78f489bd0c16"
    }
  ],
  "crossToolResidualFrontier": {
    "id": "cross-tool-trajectory-residual-frontier",
    "title": "Cross-tool trajectory residual frontier",
    "requiredContractIds": [
      "orekit-propagation-v1",
      "gmat-transfer-v1",
      "tudat-transfer-v1"
    ],
    "requiredTools": [
      "Orekit",
      "NASA GMAT",
      "Tudat"
    ],
    "currentState": "blocked-until-orekit-gmat-tudat-runtime-artifacts-promote",
    "decisionUseAllowed": false,
    "customerUseAllowed": false,
    "commercialUseAllowed": false,
    "scenarioRefs": [
      {
        "scenarioId": "asteroid-first",
        "rank": 3,
        "decisionLane": "lane-4-research-backlog",
        "decisionReadinessScore": 41.63
      },
      {
        "scenarioId": "hybrid",
        "rank": 2,
        "decisionLane": "lane-3-watchlist",
        "decisionReadinessScore": 59.78
      },
      {
        "scenarioId": "mercury-orbit",
        "rank": 4,
        "decisionLane": "lane-4-research-backlog",
        "decisionReadinessScore": 44.15
      },
      {
        "scenarioId": "moon-first",
        "rank": 1,
        "decisionLane": "lane-2-conditional-diligence",
        "decisionReadinessScore": 62.91
      }
    ],
    "residualBoundsRequired": [
      "position residual bound in km at agreed epochs",
      "velocity residual bound in m/s at agreed epochs",
      "delta-v or objective residual bound where transfer optimization is used",
      "scenario rank/uncertainty before-after delta from accepted residuals"
    ],
    "blockers": [
      "Current-shell reproducibility is not closed for decision use.",
      "Missing command/runtime: GMAT",
      "Missing command/runtime: Java",
      "Missing path or env input: OREKIT_DATA_PATH",
      "Missing path or env input: OREKIT_SIDECAR_JAR",
      "Missing Python module: tudatpy",
      "No promoted runtime artifact is available for this contract.",
      "Runtime artifact is not promoted."
    ],
    "nextAction": "Generate Orekit, GMAT, and Tudat runtime artifacts, pass intake validation, then attach before/after scenario decision deltas before changing customer-facing rankings.",
    "frontierHash": "sha256-5f373cd291bb2bf4f7223e88833fa00a8f6dd52b042b1d153c94f31fc4ab1c9d"
  },
  "markdownPath": "public/trajectory-validation-matrix.md",
  "markdownHash": "sha256-886b8b73bb331ff3b806b271bd17f75dda3a13b9c122da31a83fae15c66ca65f",
  "matrixHash": "sha256-16cd41ff7950bb20d30207308ae8694f4b5cf91faa31f3323bfe10608f7a4e2e"
}
;
